<template>
  <div class="mod-modify-password-by-mobile">
    <van-nav-bar
      title="找回密码"
      left-arrow
      left-text=""
      right-text=""
      fixed
      @click-left="onClickLeft"
    />
    <van-form ref="form" error-message-align="right" input-align="right" @submit="onSubmit">
      <van-field
        v-model="mobile"
        label="手机号码"
        maxlength="11"
        placeholder="请输入手机号"
        type="number"
        @blur="handleCheckMobile"
        :error-message="mobileErrMsg"
      />
      <van-field
        v-model="code"
        clearable
        label="验证码"
        type="number"
        placeholder="请输入短信验证码"
        :error-message="errMsg"
        @blur="handleCheckCode"
        @input="() => { checkForNumber = false }"
      >
        <template #button>
          <getCode @change="onGetCode" />
        </template>
      </van-field>
      <van-field
        v-model="userPasswd"
        :type="useType"
        name="userPasswd"
        label="新密码"
        placeholder="请输入新密码"
        maxlength="16"
        clearable
        :rules="[{ required: true, message: '请输入新密码' }, {validator: checkPassword, message: '密码格式错误，请输入6位以上密码'},{validator: checkPassStrength,message:'密码至少6位且含字母、数字、符号中2种'}]"
        @blur="useType='password'"
        @focus="useType='text'"
        @input="fiteruserPasswd"
      />
      <van-field
        v-model="userPasswdConfirm"
        :type="confimType"
        name="userPasswdConfirm"
        label="确认新密码"
        maxlength="16"
        clearable
        placeholder="请再次输入新密码"
        :rules="[{ required: true, message: '请再次输入新密码' },
                 {validator: checkPassword, message: '密码格式错误，请输入6位以上密码'},
                 ,{validator: checkPassStrength,message:'密码至少6位且含字母、数字、符号中2种'},
                 {validator: checkConfimWord, message: '前后密码输入不一致，请重新输入'}
        ]"
        @blur="confimType='password'"
        @focus="confimType='text'"
        @input="fiteruserPasswdConfirm"
      />
      <div style="margin: 16px;">
        <van-button block type="info" native-type="submit" :disabled="!cansubmit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import getCode from './get-code.vue'
import Vue from 'vue'
import 'vant/lib/index.css'
import { Form, Field, Button, Toast, NavBar } from 'vant'
import Server from '@/pc_login/api.js'
import { analyzeAgent } from '@/pc_login/isMobile.js'
Vue.use(Field)
Vue.use(Form)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Toast)
export default {
  components: {
    getCode
  },
  data () {
    return {
      mobile: '',
      code: '',
      userPasswd: '',
      useType: 'text',
      userPasswdConfirm: '',
      confimType: 'text',
      shouldCheckTotal: false,
      checkForNumber: false,
      mobileErrMsg: '',
      errMsg: ''
    }
  },
  created () {
    if (!analyzeAgent(navigator.userAgent)) {
      this.$router.push({ path: '/auth', query: this.$route.query })
    }
  },
  computed: {
    cansubmit () {
      return this.mobile && this.code && this.userPasswd && this.userPasswdConfirm
    }
  },
  mounted () {
    this.$apis = Server
    this.shouldCheckTotal = (Number(this.getCookieUtil('_m_getcode')) || 0) > 5
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    validatorPass (pass) {
      if (pass) {
        if (pass.length < 6) {
          return 1
        }
        // eslint-disable-next-line no-useless-escape
        const regs = [/[0-9]/, /[A-Z]/, /[a-z]/, /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~]/]
        let total = 0
        for (let i = 0; i < 4; i++) {
          if (regs[i].test(pass)) {
            total = total + 1
          }
        }
        if (total === 1) {
          return 1
        }
        if (total === 2) {
          return 2
        }
        if (total > 2) {
          return 3
        }
      } else {
        return 0
      }
    },
    setCookieUtil (name, value, expires) {
      let cookieText = ''
      cookieText += encodeURIComponent(name) + '=' + encodeURIComponent(value)
      if (expires instanceof Date) {
        cookieText += '; expires=' + expires.toGMTString()
      } else {
        cookieText += '; expires=' + new Date(new Date().getTime() + 12 * 60 * 60 * 1000).toGMTString()
      }
      document.cookie = cookieText
    },
    getCookieUtil (name) {
      const cookieName = encodeURIComponent(name) + '='
      const cookieStart = document.cookie.indexOf(cookieName)
      let cookieValue = ''
      if (cookieStart !== -1) {
        let cookieEnd = document.cookie.indexOf(';', cookieStart)
        if (cookieEnd === -1) {
          cookieEnd = document.cookie.length
        }
        cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd))
      }
      return cookieValue
    },
    onGetCode (done) {
      this.handleCheckMobile((e) => {
        if (e) {
          const total = Number(this.getCookieUtil('_m_getcode')) || 0
          if (total === 5) {
            this.shouldCheckTotal = true
            this.setCookieUtil('_m_getcode', 6, new Date(Date.now() + 5 * 60 * 1000))
            setTimeout(() => {
              this.shouldCheckTotal = false
            }, 5 * 60 * 1000)
            this.checkForNumber = true
            this.handleCheckCode()
          }
          if (total > 5) {
            this.checkForNumber = true
            this.handleCheckCode()
          }
          if (total < 5) {
            this.errMsg = ''
            this.setCookieUtil('_m_getcode', total + 1, new Date(Date.now() + 2 * 60 * 1000))
            this.$apis.postPhoneCode({
              phone: this.mobile,
              type: 2
            }).catch(({ response }) => {
              Server.message(Toast, response)
            })
            done && done()
          }
        }
      })
    },
    handleCheckMobile (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.mobile) {
        this.mobileErrMsg = '请输入手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (!/^1[0-9]{10}$/.test(this.mobile)) {
        this.mobileErrMsg = '请输入正确的手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.$apis.CheckPhoneValidate(this.mobile).then(({ data }) => {
          if (data.result) {
            this.mobileErrMsg = ''
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(true)
          } else {
            this.mobileErrMsg = '该手机号未注册'
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(false)
          }
        }).catch(({ response }) => {
          Server.message(Toast, response)
        })
      }
    },
    handleCheckCode (e) {
      const callback = typeof e === 'function' ? e : ''
      this.errMsg = ''
      if (!this.code && !this.checkForNumber) {
        this.errMsg = '请输入验证码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (!/^\d{6}$/.test(this.code)) {
        this.errMsg = '请输入6位数验证码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (this.checkForNumber) {
        this.errMsg = '操作过于频繁，请休息5分钟再试'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.$apis.checkPhoneCode({
          phone: this.mobile,
          type: 2,
          code: this.code
        }).then(({ data }) => {
          if (data.result) {
            this.errMsg = ''
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(true)
          } else {
            this.errMsg = '校验失败'
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(false)
          }
        }).catch(res => {
          const response = res.response
          if (response && response.status === 400 && response.data && (response.data.msg === '验证码错误' || response.data.msg === '验证码已失效，请重新获取' || response.data.msg === '验证码已失效,请重新获取')) {
            this.errMsg = response.data.msg
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(false)
          } else {
            Server.message(Toast, res.response)
            // eslint-disable-next-line standard/no-callback-literal
            callback && callback(false)
          }
        })
      }
    },
    checkPassStrength (val) {
      return this.validatorPass(val) > 1
    },
    checkPassword (val) {
      return (val || '').length >= 6
    },
    checkConfimWord (value) {
      if (!this.userPasswd || this.userPasswd === value) {
        return true
      } else {
        return false
      }
    },
    fiteruserPasswd (value) {
      value = value.replace(/[\s\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g, '')
      this.userPasswd = value
    },
    fiteruserPasswdConfirm (value) {
      value = value.replace(/[\s\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g, '')
      this.userPasswdConfirm = value
    },
    onSubmit () {
      this.checkForNumber = false
      this.errMsg = ''
      this.handleCheckMobile((result) => {
        if (result) {
          this.handleCheckCode((res) => {
            if (res) {
              this.$apis.findPassword({
                phone: this.mobile,
                code: this.code,
                userPasswd: this.userPasswd,
                userPasswdConfirm: this.userPasswdConfirm
              }).then(res => {
                this.$toast('密码修改成功！')
                setTimeout(() => {
                  const backUrl = window.sessionStorage.getItem('backUrl')
                  this.$tools.auth.clearToken()
                  this.$tools.auth.clearCurrentUserInfo()
                  window.sessionStorage.clear()
                  window.location.href = '//sso.jwyun.net/#/auth?backUrl=' + encodeURIComponent(backUrl || '//mps.jwyun.net/m/')
                }, 500)
              }).catch(res => {
                const response = res.response
                if (response && response.status === 400 && response.data && (response.data.msg === '验证码错误' || response.data.msg === '验证码已失效，请重新获取' || response.data.msg === '验证码已失效,请重新获取')) {
                  this.errMsg = response.data.msg
                } else {
                  Server.message(Toast, res.response)
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.mod-modify-password-by-mobile{
  box-sizing: border-box;
  padding-top: 50px;
  .van-field--error .van-field__control {
    color: #323233;
  }
  .van-field--error .van-field__control::-moz-placeholder {
    color: #C0C4CC;
  }
  .van-field--error .van-field__control:-ms-input-placeholder {
    color: #C0C4CC;
  }
  .van-field--error .van-field__control::placeholder {
    color: #C0C4CC;
  }
}
</style>
